export function getPairSettingsKey(pair) {
  return `${pair.platform}_${String(pair.pair_1).toLowerCase()}_${String(pair.pair_2).toLowerCase()}`;
}

export function getPairOverviewDisplayKey(pair) {
  return `${getPairSettingsKey(pair)}_overview_display`;
}

export function isPairShownInOverview(settings, pair) {
  const key = getPairOverviewDisplayKey(pair);
  const value = settings?.[key];
  if (value === undefined || value === null || value === '') {
    return true;
  }
  return value === true || value === 1 || value === '1' || value === 'true';
}
